<template>
<div>
	<!-- <el-row class="gPageBorder">
	  	<el-form :model="userinfo" class='gForm' label-position="right" style="" id="userInfo" label-width="12.5%">
	  		<el-form-item :label="$t('lin_global.name')">
	          {{ userinfo.name}}
	        </el-form-item>
	        <el-form-item :label="$t('lin_global.version')">
	          {{ userinfo.version }}
	        </el-form-item>
	        <el-form-item :label="$t('lin_global.label_areaid')">
	          {{ qudao }}
	        </el-form-item>
	        <el-form-item>
	          <el-button type="info" @click="showTableE">{{$t('lin_global.tsazcs')}}</el-button>
	        </el-form-item>
	        <el-form-item :label="$t('lin_global.shzt')">
			    <el-radio-group v-model="radio" @change="change">
			      <el-radio label="2">{{$t('lin_global.pass')}}</el-radio>
			      <el-radio label="3">{{$t('lin_global.notPass')}}</el-radio>
			    </el-radio-group>
			</el-form-item>
			<el-form-item v-if="ifshow" :label="$t('lin_global.shyy')">
				<el-input type="textarea" v-model="content" style="width:100%"></el-input>
			</el-form-item>
	        <el-form-item>
	          <el-button @click="onCancel">{{$t('lin_btn.cancel')}}</el-button>
	          <el-button type="primary" @click="submit">{{$t('lin_btn.submit')}}</el-button>
	        </el-form-item>

	  	</el-form>
	</el-row> -->

	<el-dialog class='gDia' :title="dtitle" v-model="dialogVisible" size='small'>
      <p style='margin-top:-8px;'>{{$t(ddes)}}</p>
      <el-input pplaceholder="$t('app_plsip') + $t('app_banReason')" type="textarea" v-model="content" style="width:100%;margin-top:16px;"></el-input>

      <div slot="footer" style='margin-top:-20px;' class="dialog-footer">
	    <el-button @click="dialogVisible = false">{{$t('app_cancel')}}</el-button>
	    <el-button  type="primary" @click="submit('3')">{{$t('app_suresm')}}</el-button>
	  </div>
    </el-dialog>

	<el-row class='gPageBorder gTopMg gPdTB'>
      <el-col :span='12'>
        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
          <el-form-item :label="ota + $t('app_name') ">
            {{ userinfo.name}}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowRightForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('lin_global.version') ">
            {{ userinfo.version }}
          </el-form-item>
        </el-form>
      </el-col>

      <el-col :span='12'>
        <el-form class='gShowLeftForm' label-position='left' label-width="30%">
          <el-form-item :label="$t('app_distributor') ">
            {{ qudao }}
          </el-form-item>
        </el-form>
      </el-col>

       <el-col style='margin-left:24px;margin-bottom:12px;'>
         <el-button @click="onCancel">{{$t('lin_btn.cancel')}}</el-button>
         <el-button type='success' @click="submit('2')">{{$t('app_psverify')}}</el-button>
         <el-button type='danger' @click="dialogVisible = true;">{{$t('app_ban')}}</el-button>
         <el-button style='margin-left:20px;' type="info" @click="showTableE">{{$t('lin_global.tsazcs')}}</el-button>
       </el-col>
	</el-row>

	<el-dialog class='gDia' style='' size='small' :title="$t('lin_global.zdtslb')" v-model="showTable">
		<el-row gutter="" style="">
			<el-col :span="6">
		        <el-input
              :placeholder="$t('lin_global.label_no')"
	  			  icon="search"
	  			  v-model="input1"
	  			  :on-icon-click="handleIconClick"
            @keyup.enter.native="focusEvent(handleIconClick)">
	  			</el-input>
	        </el-col>
		</el-row>

		<el-table
	  	:data="arrdata"
	  	border
	  	style="width:100%"
	  	class='gTopMg'
	  	ref="arrdata">
      <el-table-column
        prop="terminalName"
        :label="$t('lin_global.label_name')"
        width="200">
      </el-table-column>
	  		<el-table-column
	  		prop="terminalNo"
        :label="$t('lin_global.label_no')"
	  		width="140">
	  		</el-table-column>
	  		<el-table-column
          :label="$t('lin_global.status')"
	  		width="80">
		  		<template slot-scope="scope">
		  			<el-tag v-if="scope.row.terminalStatus == 1 " type="success" size="mini">{{$t('lin_global.online')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 2 " type="danger" size="mini">{{$t('lin_global.offline')}}</el-tag>
                    <el-tag v-if="scope.row.terminalStatus == 0 " type="gray" size="mini">{{$t('lin_global.new_add')}}</el-tag>
										<el-tag v-if="scope.row.terminalStatus == 3 " type="warning" size="mini">{{$t('app_sleep')}}</el-tag>
		  		</template>
	  		</el-table-column>

	  		<el-table-column
	  		prop="mechName"
        :label="$t('lin_global.label_areaid')">
	  		</el-table-column>
	  		<el-table-column width="80"
          :label="$t('lin_global.ope')">
				<template slot-scope="scope">
					<!-- <el-button @click.stop="give(scope.row.terminalNo)" type="text">{{$t('lin_btn.send')}}</el-button> -->
					<el-tooltip class="item" effect="dark" :content="$t('lin_btn.send')" placement="top">
						<el-button type='text' @click.stop="give(scope.row.terminalNo)"><i class="fa fa-upload" style=""></i></el-button>
					</el-tooltip>
				</template>
	  		</el-table-column>
	  	</el-table>
	  	<div class="gPgDiv">
		  <el-pagination
		    class='gPg'
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    :current-page="currentPage"
		    :page-sizes="[10,50,100]"
		    :page-size="pageSize"
		    layout="total, sizes, prev, pager, next, jumper"
		    :total="totalRecords">
		  </el-pagination>
		</div>
	</el-dialog>
</div>
</template>
<script>
	import axios from 'axios'
    import { baseurl,focusEvent } from '../../api/url'
	export default{
		data(){
			return{
				dialogVisible: false,
			    ota: "OTA",
        		focusEvent: focusEvent,
				ifshow:false,
				radio:'',
				content:'',
				showTable:false,
				qudao:'',
				arrdata:[],
				userinfo:{},
				currentPage: 1,
				pageSize: 10,
				input1:'',
				totalRecords: 0
			}
		},
		created(){
			this.getDetail();
			this.getData(1,'')
		},
		mounted () {
		},
		computed: {
		  dtitle () {
		    return this.$t('app_srban')
		  },
		  ddes () {
		    return this.$t('app_banandrs')
		  }
		},
		methods:{
			change(){
				if(this.radio == '3'){
					this.ifshow = true
				}else{
					this.ifshow = false
				}
			},
			give(no){
				var romId = this.$route.params.id;
				let token = localStorage.getItem('user');
				var params = {ota_rom_id:romId,type:"1",token:token,targetId:no};
				//console.log("查看传参");
				//console.log(params)
				axios.post(`${baseurl}/ota_rom/push.do`,params).then(res=>{
					//console.log("查看推送返回信息")
					//console.log(res.data);
					/*if(res.data.status == 200){
						this.userinfo = res.data.data;
						if(res.data.data.mechanismName!==''){
							this.qudao = res.data.data.mechanismName
						}else{
							this.qudao = '所有渠道商'
						}
					}*/
					if(res.data.status == 200){
						this.$message(this.$t('lin_global.task_tips2'))
					}else{
						this.$message.error(res.data.message)
					}
				})
			},
			showTableE(){
				this.showTable = true;
			},
			handleIconClick(){
		    	this.getData(1,this.input1)
		    },
			getData(page,no){

		        this.currentPage = page;
				var params = {
					page:page,
					rows:this.pageSize,
					terminal_no:no,
          areaid:'',
          terminal_status:'',
          terminal_runtime_status:''
				}
				//console.log("打印传出参数");
				//console.log(params);
				axios.post(`${baseurl}/terminal/list.do`, params).then(res=> {
				  //console.log("打印返回列表");
				  //console.log(res.data);
				  if(res.data.status == 200){
				  	this.arrdata = res.data.data;
		          	this.totalRecords = res.data.total;
				  }else{

				  }

		        }).catch(function (error) {

		        })
			},
			formatStatus:function(row,column){
					/*return row.terminal_status == 0 ? this.$t('lin_global.new_add') : row.terminal_status == 1 ? this.$t('lin_global.online') : row.terminal_status == 2 ? this.$t('lin_global.offline') : '';*/
					switch(row.terminal_status) {
						case '0':
						 return this.$t('lin_global.new_add')
						 break
						case '1':
						 return this.$t('lin_global.online')
						 break
						case '2':
						 return this.$t('lin_global.offline')
						 break
						case '3':
						 return this.$t('app_sleep')
						 break
					}
		    },
		    handleSizeChange: function (val) {
		        this.pageSize = val
		        this.getData(this.currentPage,'')
		        //console.log(`每页 ${val} 条`)
		    },
		    handleCurrentChange: function (val) {
		        this.currentPage = val
		        this.getData(this.currentPage,'')
		        //console.log('当前页: ${val}')
		    },
			submit:function(vl){
			    // this.radio
				let token = localStorage.getItem('user');
				var romId = this.$route.params.id;
				var params = {token:token,ota_rom_id:romId,content:this.content,status: vl};
				if(/*!this.radio*/false){
				    this.$message.error(this.$t('lin_global.xztghbtg'));
		        }else{
		          if (vl === '3') {
		            if (!this.content) {
		              this.$message.error(this.$t('app_noInput') + this.$t('app_banReason'))
		              return
		            }
		            axios.post(`${baseurl}/ota_rom/audit.do`,params).then(res=>{
			          //console.log(res.data)
			          if (res.data.status == 200) {
			            this.$message.success(this.$t('lin_global.shcg'))
			            this.getData(1,'');
			            this.$router.go(-1);
			          } else {
			            this.$message.error(res.data.message)
			          }
			        })
			        return
		          }
		          this.$confirm(this.$t('lin_global.qrtj'), this.$t('lin_btn.tips'), {
		            confirmButtonText: this.$t('lin_btn.confirm'),
		            cancelButtonText: this.$t('lin_btn.cancel'),
		            type: 'warning'
		          }).then(() => {
		            axios.post(`${baseurl}/ota_rom/audit.do`,params).then(res=>{
		            
			          //console.log(res.data)
			          if (res.data.status == 200) {
			            this.$message.success(this.$t('lin_global.shcg'))
			            this.getData(1,'');
			            this.$router.go(-1);
			          } else {
			            this.$message.error(res.data.message)
			          }
			        })
		        }).catch(() => {

		          })
		        }

			},
			getDetail:function(){
				var romId = this.$route.params.id;
				var params = {id:romId};
				axios.post(`${baseurl}/ota_rom/detail.do`,params).then(res=>{
					//console.log(res.data);
					if(res.data.status == 200){
						this.userinfo = res.data.data;
						if(res.data.data.mechanismName!==''){
							this.qudao = res.data.data.mechanismName
						}else{
							this.qudao = this.$t('lin_global.all_mechanism')
						}
					}
				})
			},
			onCancel:function(){
				this.$router.go(-1);
			}
		}
	}
</script>



// WEBPACK FOOTER //
// reviewDetail.vue?26c07732